import { useEffect } from 'react';

const DEFAULT_TITLE = 'EntoRid | Professional Pest Control Services';
const DEFAULT_DESC = 'EntoRid provides safe, eco-friendly pest control solutions for homes and businesses. Trusted protection for your family and property.';

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [a, v] = selector.replace(/[[\]"]/g, '').split('=');
    el.setAttribute(a, v);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/**
 * Sets page-level SEO metadata.
 * @param {string} title - Page-specific suffix, e.g. "Home" -> "EntoRid | Home"
 * @param {string} [description] - Page-specific meta description
 */
export default function useSeo(title, description) {
  useEffect(() => {
    const fullTitle = title ? `EntoRid | ${title}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', desc);
  }, [title, description]);
}
